import {Component, OnInit} from '@angular/core';
import {PriceRobotRule, PriceRobotRuleAction, PriceRobotRuleCondition} from "../services/price-robot-rule";
import {PriceRobotCompetitorService} from "../services/price-robot-competitor.service";
import {PriceRobotRulesService} from "../services/price-robot-rules.service";
import {ActivatedRoute, Router} from "@angular/router";
import {PriceRobotMessageService} from "../services/price-robot-message.service";
import {CategoriesService, VariantsService} from "@hassel-it/shop-services";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import * as _ from "lodash";
import {isArray, isNull} from "lodash";


@Component({
    providers: [VariantsService, CategoriesService],
    selector: 'app-price-robot-rules',
    templateUrl: './price-robot-rules.component.html',
    styleUrls: ['./price-robot-rules.component.scss']
})
export class PriceRobotRulesComponent implements OnInit {

    public param: any;

    public rule: PriceRobotRule = new PriceRobotRule();
    public ruleActions: PriceRobotRuleAction[] = [];
    public ruleConditions: PriceRobotRuleCondition[] = [];

    public competitors: any;
    public variants: any;
    public products: any;
    public categories: any;

    public loading: boolean = false;

    dropdownSettings: IDropdownSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'name',
        allowSearchFilter: true,
        itemsShowLimit: 5,
        enableCheckAll: true,
        selectAllText: 'Vælg alle',
        unSelectAllText: 'Fravælg alle',
    };

    constructor(private priceRobotCompetitorService: PriceRobotCompetitorService,
                private variantsService: VariantsService,
                private categoriesService: CategoriesService,
                private rulesService: PriceRobotRulesService,
                private priceRobotMessageService: PriceRobotMessageService,
                private route: ActivatedRoute,
                private router: Router,
                public ngbModal: NgbModal) {
    }

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.param = params.get('ruleId');

            if (this.param !== '0') {
                this.loadData();
            } else {
                this.priceRobotCompetitorService.index().subscribe(result => {
                    this.competitors = result['competitors'];
                }, error => {
                    this.priceRobotMessageService.handleError(error);
                });

                this.variantsService.getVariants({variant_groups: [1], no_pagination: true}).then(result => {
                    this.variants = result.results;
                });

                this.categoriesService.getCategoriesAdmin({}).subscribe(result => {
                    this.categories = result.results;
                });
            }
        })

    }

    loadData() {
        this.loading = true;

        this.rulesService.view(this.param).subscribe(result => {
            let data: any = result;
            let rule: any = data.rule;
            let rule_actions: any = rule.rules_actions;
            let rule_conditions: any = rule.rules_conditions;

            this.parseRuleFromDatabase();

            /**
             * Omdanner datoer så de passer til input date
             */
            if (rule.active_start !== null) {
                rule.active_start = new Date(rule.active_start).toISOString().split('T')[0];
            }

            if (rule.active_end !== null) {
                rule.active_end = new Date(rule.active_end).toISOString().split('T')[0];
            }

            this.rule = new PriceRobotRule(rule.id, rule.name, rule.is_active, rule.active_start, rule.active_end)

            this.ruleActions = rule_actions;
            this.ruleConditions = rule_conditions;
            this.loading = false;
        }, error => {
            this.priceRobotMessageService.handleError(error);
            this.loading = false;
        });

        this.priceRobotCompetitorService.index().subscribe(result => {
            this.competitors = result['competitors'];

            this.parseRuleFromDatabase();

            this.loading = false;
        }, error => {
            this.priceRobotMessageService.handleError(error);
            this.loading = false;
        });

        this.variantsService.getVariants({variant_groups: [1], no_pagination: true}).then(result => {
            this.variants = result.results;

            this.parseRuleFromDatabase();

        });

        this.categoriesService.getCategoriesAdmin({}).subscribe(result => {
            this.categories = result.results;

            this.parseRuleFromDatabase();

        });
    }

    addCondition() {
        this.ruleConditions.push(new PriceRobotRuleCondition());
    }

    removeCondition(index: number) {
        if (confirm('Er du sikker på at du vil fjerne dette kriterie')) {
            if (index >= 0) {
                this.ruleConditions.splice(index, 1);
            }
        }
    }

    addAction() {
        this.ruleActions.push(new PriceRobotRuleAction());
    }

    removeAction(index: number) {
        if (confirm('Er du sikker på at du vil fjerne denne handling')) {
            if (index >= 0) {
                this.ruleActions.splice(index, 1);
            }
        }
    }

    setProduct(condition: PriceRobotRuleCondition) {
    }

    parseRuleFromDatabase() {
        /**
         * Handle rule conditions for dropdown
         */
        for (let condition of this.ruleConditions) {
            // Competitor
            if (!isArray(condition.competitor_id)) {
                let competitorIds = "" + condition.competitor_id;

                let competitors = [];

                for (let competitorId of competitorIds.split(',')) {
                    if (competitorId === 'null' || competitorId === '' || isNull(competitorId)) {
                        continue;
                    }

                    let competitor = this.competitors ? this.competitors.filter((competitor) => {
                        return competitor.id == competitorId;
                    }) : [];

                    competitors.push({
                        id: parseInt(competitorId),
                        name: competitor.length > 0 ? competitor[0].name : '...'
                    });
                }

                condition.competitor_id = competitors;
            } else if (this.competitors) {
                for (let competitor of condition.competitor_id) {
                    if (competitor.name === '...') {
                        let filteredCompetitor = this.competitors.filter((e) => {
                            return e.id == competitor.id;
                        });

                        if (filteredCompetitor.length > 0) {
                            competitor.name = filteredCompetitor[0].name;

                            console.log('Competitor name fixed'); // @todo Debug help when we fixed the data because the rule was loaded first
                        }
                    }
                }
            }

            // Variant
            if (!isArray(condition.variant_id)) {
                let variantIds = "" + condition.variant_id;

                let variants = [];

                for (let variantId of variantIds.split(',')) {
                    if (variantId === 'null' || variantId === '' || isNull(variantId)) {
                        continue;
                    }

                    let variant = this.variants ? this.variants.filter((variant) => {
                        return variant.id == variantId;
                    }) : [];

                    variants.push({
                        id: parseInt(variantId),
                        name: variant.length > 0 ? variant[0].name : '...'
                    });
                }

                condition.variant_id = variants;
            } else if (this.variants) {
                for (let variant of condition.variant_id) {
                    if (variant.name === '...') {
                        let filteredVariants = this.variants.filter((e) => {
                            return e.id == variant.id;
                        });

                        if (filteredVariants.length > 0) {
                            variant.name = filteredVariants[0].name;

                            console.log('Variant name fixed'); // @todo Debug help when we fixed the data because the rule was loaded first
                        }
                    }
                }
            }

            // Category
            if (!isArray(condition.category_id)) {
                let categoryIds = "" + condition.category_id;

                let categorys = [];

                for (let categoryId of categoryIds.split(',')) {
                    if (categoryId === 'null' || categoryId === '' || isNull(categoryId)) {
                        continue;
                    }

                    let category = this.categories ? this.categories.filter((category) => {
                        return category.id == categoryId;
                    }) : [];

                    categorys.push({
                        id: parseInt(categoryId),
                        name: category.length > 0 ? category[0].name : '...'
                    });
                }

                condition.category_id = categorys;
            } else if (this.categories) {
                for (let category of condition.category_id) {
                    if (category.name === '...') {
                        let filteredCategories = this.categories.filter((e) => {
                            return e.id == category.id;
                        });

                        if (filteredCategories.length > 0) {
                            category.name = filteredCategories[0].name;

                            console.log('Category name fixed'); // @todo Debug help when we fixed the data because the rule was loaded first
                        }
                    }
                }
            }
        }
    }

    prepareRuleForDatabase(): PriceRobotRule {
        let rule = _.cloneDeep(this.rule);

        for (let condition of rule.rules_conditions) {
            // Competitor
            let competitorId = [];

            if (isArray(condition.competitor_id)) {
                for (let competitor of condition.competitor_id) {
                    competitorId.push(competitor.id);
                }
            } else {
                competitorId = [condition.competitor_id];
            }

            condition.competitor_id = competitorId.join(',');

            // Variant
            let variantId = [];

            if (isArray(condition.variant_id)) {
                for (let variant of condition.variant_id) {
                    variantId.push(variant.id);
                }
            } else {
                variantId = [condition.variant_id];
            }

            condition.variant_id = variantId.join(',');

            // Category
            let categoryId = [];

            if (isArray(condition.category_id)) {
                for (let category of condition.category_id) {
                    categoryId.push(category.id);
                }
            } else {
                categoryId = [condition.category_id];
            }

            condition.category_id = categoryId.join(',');
        }

        return rule;
    }

    addRule() {
        this.loading = true;

        this.rule.rules_actions = this.ruleActions;
        this.rule.rules_conditions = this.ruleConditions;

        this.rulesService.add(this.prepareRuleForDatabase()).subscribe(result => {
            this.loading = false;

            this.router.navigateByUrl('/price-robot/rule/' + result['rule']['id']);
        }, error => {
            this.priceRobotMessageService.handleError(error);
            this.loading = false;
        })
    }

    editRule() {
        this.loading = true;

        this.rule.rules_actions = this.ruleActions;
        this.rule.rules_conditions = this.ruleConditions;

        this.rulesService.edit(this.prepareRuleForDatabase()).subscribe(_ => {
            this.loading = false;
        }, error => {
            this.priceRobotMessageService.handleError(error);
            this.loading = false;
        })
    }

    deleteRule() {
        if (confirm('Er du sikker på at du vil fjerne denne regel')) {
            this.rulesService.delete(this.rule).subscribe((_) => {
                this.router.navigateByUrl('/price-robot/rules');
            });
        }
    }

    duplicateRule() {
        let name = prompt("Hvad skal den nye regel hedde ?", this.rule.name);

        if (name != null) {
            this.rulesService.duplicate(this.rule, name).subscribe((result) => {
                this.router.navigateByUrl('/price-robot/rule/' + result['rule']['id']);
            });
        }
    }
}
